<template>
	<div class="wrap">
		<h1> Контакты </h1>
		<hr>
		<h3>БИЗНЕС ЦЕНТР</h3>
		<p>618419 Пермский край г. Березники ул. Карла Маркса д. 48 оф.202<br>
			Офис располагается в здании делового центра на 2 этаже<br>
			Тел. 3424 29 25 13<br>
		Эл. почта: info@ligasound.ru</p>
		<br>
		<h3>Режим работы:</h3>
		<p> ПН-ПТ: 10:00 – 18:00<br>
			СБ: 10:00-15:00<br>
			ВС: Выходной</p>
		<br>
		<h3>Юридическая информация</h3>
        <p><strong>Полное наименование:</strong> Общество с ограниченной ответственностью "ЛИГА САУНД СИСТЕМ"
            ИНН 5911069479, КПП 591101001, ОГРН 1135911001148, ОКПО 24063531</p>
        <p><strong>Юридический адрес:</strong> 618419, Пермский край г. Березники, ул. Карла Маркса, дом 48, офис 202</p>
        <p><strong>Фактический адрес:</strong> 618419, Пермский край г. Березники, ул. Карла Маркса, дом 48, офис 202</p>
        <p><strong>Расчетный счет:</strong> 40702810149030070188
        <p><strong>Банк:</strong> Волго-Вятский банк ПАО Сбербанк г. Нижний Новгород БИК 042202603 корр/счет 30101810900000000603</p>

	<div class="map-wrap">
		<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1015.3564074390383!2d56.80253964558258!3d59.40450372794725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd9088cc02239fa0c!2sLiga+Sound+System!5e0!3m2!1sru!2sru!4v1518592588819" width="600" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
	</div>
	<br>
	<br>
</div>
</template>

<script >
export default{

};
</script>

<style scoped>
.wrap{
	margin: 20px;
}
.map-wrap{
	text-align: center;
}

@media(max-width: 1000px){
	iframe{
		width: 600px;
	}
}


@media(max-width: 768px){
	iframe{
		width: 600px;
	}



}
@media(max-width: 560px){
	iframe{
		width: 280px;
	}
}
</style>